import React, { useEffect } from "react";
import { Script } from "gatsby";

export default function HubspotChat() {
/*   useEffect(() => {
    const hubspotChatReady = () => {
      window.HubSpotConversations.on("conversationStarted", () => {
        sessionStorage.setItem("chatInProgress", "true");
      });

      window.HubSpotConversations.on("conversationClosed", () => {
        sessionStorage.removeItem("chatInProgress");
      });

      const $liveChat = document.getElementById("hs-script-loader");
      if ($liveChat) {
        console.log("LIVE CHAT IS LOADED");
        $liveChat.style.display = "block";
        $liveChat.addEventListener("click", function (event) {
          event.preventDefault();
          $liveChat.classList.add("loading");

          const observer = new MutationObserver((mutationList) => {
            mutationList.forEach((mutation) => {
              Array.from(mutation.addedNodes).forEach((node) => {
                if (node.id === "hubspot-messages-iframe-container") {
                  const iframe = node.querySelector("iframe");
                  if (iframe) {
                    iframe.addEventListener("load", function () {
                      $liveChat.classList.remove("loading");
                      window.HubSpotConversations.widget.open();
                      observer.disconnect();
                    });
                  }
                }
              });
            });
          });

          observer.observe(document.body, { childList: true });
          window.HubSpotConversations.widget.load({ widgetOpen: true });
        });
      }
    };

    if (window.HubSpotConversations) {
      window.hsConversationsSettings = { loadImmediately: false };
      hubspotChatReady();
    } else {
      window.hsConversationsOnReady = [hubspotChatReady];
    }
  }, []); */

  return (
    <Script
      type="text/javascript"
      id="hs-script-loader"
      strategy="idle"
      async
      defer
      src="//js.hs-scripts.com/8495702.js"
    ></Script>
  );
}
